import FlashLib from 'flashlib_onlyplay';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import EntryPoint from 'Engine/EntryPoint';
import { jackpotStrokes, jackpotValues, mainGoldFont } from '../fontStyles';
import MoneyFormat from 'Engine/base/moneyFormat/MoneyFormat';

export default class PaytableContent extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);

    this.currentFrame = 1;
    this.addListeners();
  }

  addListeners() {
    GlobalDispatcher.add('paytable:backClick', this.reset, this);
    GlobalDispatcher.add('paytable:changePage', this.changeFrame, this);
  }

  setMultipliers() {
    switch (this.currentFrame) {
      case 2:
        for (let i = 0; i <= 2; i++) {
          const label = this.children[0].getChildByName(`jackpot_panels_${i}`);
          const value = this.children[0].getChildByName(`jackpot_value_${i}`);
          value.text = MoneyFormat.formatCurrency(EntryPoint.GameModel.jackpotList[2 - i], EntryPoint.GameModel.currencyInfo.decimals);
          value.style = { ...value.style, ...jackpotValues, ...jackpotStrokes[i] };
          label.style = { ...label.style, ...mainGoldFont };
        }
        break;
      case 3:
        for (let i = 0; i < 8; i++) {
          const count = this.children[0].getChildByName(`paytable_p2_count${i}`);
          const coeff = this.children[0].getChildByName(`paytable_p2_coefs${i}`);
          coeff.text = EntryPoint.GameModel.paytableInfo[i + 1][EntryPoint.GameModel.paytableInfo[i + 1].length - 1];
          count.style = {...count.style, ...mainGoldFont};
          coeff.style = {...coeff.style, ...mainGoldFont};
        }
        break;
    }
  }

  setTextsStyle() {
    for (let i = 0; i <= 3; i++) {
      const text = this.children[0].getChildByName(`paytable_${this.currentFrame - 1}_${i}`);
      if (text) {
        text.style = { ...text.style, ...mainGoldFont }
      }
    }
  }

  changeFrame(event) {
    this.currentFrame = event.params || 1;
    this.goToFrame(this.currentFrame);
    this.setMultipliers();
    this.setTextsStyle();
  }

  reset() {
    this.currentFrame = 1;
    this.goToFrame(this.currentFrame);
    this.setMultipliers();
  }

  destroy() {
    GlobalDispatcher.remove('paytable:backClick', this.reset, this);
    GlobalDispatcher.remove('paytable:changePage', this.changeFrame, this);
    super.destroy();
  }

  goToFrame(index) {
    this.libName = index === 6 ? 'jackpotGameFlashLib' : 'GameFlashLib';
    super.goToFrame(index);
  }
}
